import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TrainingType } from 'src/app/shared/enums/training-type.enum';
import { Observable, of } from 'rxjs';
import { BeforeTrainingStart } from '../../shared/interfaces/before-training-start';

@Component({
    selector: 'app-neural-network',
    templateUrl: './neural-network.component.html',
    styleUrls: ['./neural-network.component.scss'],
    standalone: false,
})
export class NeuralNetworkComponent
    extends BeforeTrainingStart
    implements OnInit
{
    @Input() trainingId: string;
    @Input() trainingType: TrainingType;
    @Input() editingIsDisabled: boolean = false;

    @ViewChild('beforeStartComponent')
    currentChild?: BeforeTrainingStart;

    selectedIndex: number = 0;

    override saveBeforeStart(): Observable<any> {
        if (this.currentChild) {
            return this.currentChild.saveBeforeStart();
        }
        return of(null);
    }

    ngOnInit(): void {
        if (this.trainingType === TrainingType.VISUAL) {
            this.selectedIndex = 1;
        }
    }

    changeSelection(selectedIndex: number) {
        this.selectedIndex = selectedIndex;
    }
}
